// extracted by mini-css-extract-plugin
export default {"pulse-green":"Referral_pulse-green__QmCGg","pendingER":"Referral_pendingER__oh35U","pulse-red":"Referral_pulse-red__ufHVB"};